<div class="shell-scrim" aria-hidden="true" (click)="closeDrawer()"></div>

<app-sidebar
  [collapsed]="isCollapsed()"
  (toggleCollapse)="toggleCollapsed()"
  (navigated)="closeDrawer()"
/>

<main class="panel">
  <header class="panel__header">
    <div class="row gap-6">
      <button
        class="btn btn--ghost btn--icon shell-menu"
        type="button"
        aria-label="Open navigation"
        [attr.aria-expanded]="isDrawerOpen()"
        (click)="toggleDrawer()"
      >
        <i class="ph ph-list" aria-hidden="true"></i>
      </button>
      <h1 class="panel__title">{{ pageTitle() }}</h1>
    </div>

    <div class="panel__actions">
      <app-user-menu />
    </div>
  </header>

  <router-outlet />
</main>
